import { render, staticRenderFns } from "./DialogFormCategoryAdd.vue?vue&type=template&id=157e8c84"
import script from "./DialogFormCategoryAdd.vue?vue&type=script&lang=js"
export * from "./DialogFormCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports